import { ErrorBoundary, useToastCookie } from '@betterment/shared-components';
import { Outlet } from 'react-router-dom';

import RenderingModeGuard from './RenderingModeGuard';
import { RouteLoaderProgress } from './RouteLoaderProgress';

import { useZendeskChatbotConfig } from '../../chatbot/zendesk-config';
import { useZendeskChatbotWidget } from '../../chatbot/zendesk-widget';
import { NoticesProvider } from '../../InAppMessages/GlobalNotices/NoticesProvider';
import { useSuspendedCookie } from '../../notifications/useSuspendedCookie';
import ScrollToTopOnPathChange from '../../Shared/components/ScrollToTopOnPathChange';
import { useSidebarRevalidator } from '../../sidebar/hooks/useSidebarRevalidator';
import { useMetricsLogger } from '../hooks/useMetricsLogger';

export function Root() {
  useMetricsLogger();
  useToastCookie();
  useSuspendedCookie();
  useSidebarRevalidator();
  useZendeskChatbotWidget(useZendeskChatbotConfig());

  return (
    <ErrorBoundary fallbackType="full">
      <ScrollToTopOnPathChange />
      <RouteLoaderProgress />
      <RenderingModeGuard>
        <NoticesProvider>
          <Outlet />
        </NoticesProvider>
      </RenderingModeGuard>
    </ErrorBoundary>
  );
}
